import React from 'react'

import {
  AlignItems,
  Body2,
  Bold,
  BorderStyle,
  Box,
  Color,
  Display,
  FlexDirection,
  Icon,
  IconVariant,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import type { OrderConfirmationRafSuccessMessage } from '@library/api-customer-engagement-experience'

const ConfirmationBanner = withCitrusTheme(Box, () => ({
  borderRadius: '8px',
}))

type CopyConfirmationProps = {
  credit: string
  isBoost?: boolean
  successMessage?: Pick<OrderConfirmationRafSuccessMessage, 'title' | 'subtitle'>
}

export const CopyConfirmation = ({
  credit,
  isBoost = false,
  successMessage,
}: CopyConfirmationProps) => {
  const title = successMessage?.title ?? 'Link copied, now send it to a friend'
  const subtitle =
    successMessage?.subtitle ?? `You'll get ${credit} credit once they get their first box.`

  return (
    <ConfirmationBanner
      display={Display.Flex}
      alignItems={AlignItems.FlexStart}
      gap={2}
      bg={isBoost ? Color.Success_900 : Color.Success_50}
      borderColor={isBoost ? Color.Success_50 : Color.Success_900}
      borderStyle={BorderStyle.Solid}
      borderWidth={0.5}
      paddingV={4}
      paddingH={4}
      role="status"
      data-testid="rafLinkCopyConfirmation"
    >
      <Box color={isBoost ? Color.Success_50 : Color.Success_900} display={Display.Flex}>
        <Icon name="success" size={[5, 5, 6]} variant={IconVariant.Inherit} />
      </Box>
      <Box display={Display.Flex} flexDirection={FlexDirection.Column}>
        <Body2 size={[2, 2, 4]} color={isBoost ? Color.Success_50 : Color.Success_900}>
          <Bold>{title}</Bold>
        </Body2>
        <Body2 size={[2, 2, 4]} color={isBoost ? Color.White : Color.ColdGrey_800}>
          {subtitle}
        </Body2>
      </Box>
    </ConfirmationBanner>
  )
}
